import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getSettingsActionAsync, resetSettingsAction } from '../redux/actions/settingsActions'

export const useSettings = () => {
  const { settingsState } = useSelector((state: RootState) => state.settings)
  const dispatch = useDispatch()

  const getSettings = (typeSettingId: number, productOriginId?: number | null) => {
    dispatch(getSettingsActionAsync(typeSettingId, productOriginId))
  }

  const resetSettings = (typeSettingId: number) => {
    dispatch(resetSettingsAction(typeSettingId))
  }

  return { settingsState, getSettings, resetSettings }
}
